<!--  -->
<template>
  <div class=''>
    <div v-show="$route.name === 'about'">
      <HeadView :title="headTitle"
                :content="headContent"
                :imgPath="headImgPath" />
      <div class="title--wrap">
        <div class="title__item--wrap"
             v-for="(item,index) in titleData"
             :key="index"
             @click="chooseItem(item,index)">
          <div class="title__item__content"
               :class="{'bold':index === curIndex}"> {{ item.title }}</div>
          <div class="title__item__underline"
               :class="{'transparent':curIndex !== index}"></div>
        </div>
      </div>

      <keep-alive>
        <component :is="curComponent"></component>
      </keep-alive>
    </div>
    <router-view></router-view>
    <foot-view></foot-view>
  </div>
</template>

<script>
import HeadView from '@/components/Head/Head.vue'
import CompanyMsgView from './components/CompanyMsg/index.vue'
import NewsCenterView from './components/NewsCenter/index.vue'
import AnnouncementView from './components/Announcement/index.vue'
export default {
  name: 'AboutView',
  components: { HeadView, CompanyMsgView, NewsCenterView, AnnouncementView },
  data () {
    return {
      headTitle: '关于我们',
      headContent: '国内领先的电子认证服务和信息安全解决方案提供商',
      headImgPath: require('../../images/gywm.png'),
      titleData: [
        { title: '公司简介', routeName: 'companyIntroduce' },
        { title: '新闻中心', routeName: 'newsCenter' },
        { title: '公告中心', routeName: 'announcementView' }
      ],
      curIndex: 0,
      curComponent: undefined

    }
  },
  computed: {},
  watch: {

  },
  // 方法集合
  methods: {
    chooseItem (item, index) {
      if (index !== this.curIndex) {
        this.curIndex = index
        this.$router.replace({ name: 'about', params: { item: item.routeName } }, () => { })
      }
    }
  },
  created () {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        console.log('aaa', toParams)
        console.log('previousParams', previousParams)
        // 对路由变化做出响应...
        if (toParams.item === 'companyIntroduce') {
          this.curComponent = CompanyMsgView
          this.curIndex = 0
        } else if (toParams.item === 'newsCenter') {
          this.curComponent = NewsCenterView
          this.curIndex = 1
        } else if (toParams.item === 'announcementView') {
          this.curComponent = AnnouncementView
          this.curIndex = 2
        } else {
          // console.log('xxx', toParams)
          // this.$router.replace({ name: 'about', params: { item: 'companyIntroduce' } }, () => { })
        }
      }, { immediate: true }
    )
  },
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.title--wrap {
  display: flex;
  justify-content: center;
  .title__item--wrap:not(:first-child) {
    margin-left: 80px;
  }

  .title__item--wrap {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &:hover {
      .title__item__content {
        color: $color-primary;
        font-weight: bold;
      }
    }
    .title__item__content {
      font-size: 18px;
      color: #333;
      margin: 16px 0;
    }
    .title__item__underline {
      width: 90%;
      height: 2px;
      background-color: $color-primary;
    }
  }
}
.bold {
  font-weight: bold;
}
.transparent {
  color: transparent;
  background-color: transparent !important;
}
</style>
